import '@iotize/tap/service/core';

import { Tap } from '@iotize/tap';

import { createMockClient, MockClient } from './mock-client';
import { MockServiceCallRunner } from './mock-service-call-runner';

export function createMockTap(options?: MockTap.InstanceOptions): MockTap {
  return new MockTap(options);
}

// export async function getMockDeviceFromSnapshot(snapshotData: RouteMapping): Promise<Tap> {
//     const protocol = MockProtocol.createFromRoutes(snapshotData);
//     return Tap.fromProtocol(protocol);
// }

export namespace MockTap {
  export interface InstanceOptions {
    connected?: boolean;
  }
}

/**
 * @experimental
 */
export class MockTap extends Tap {
  get client(): MockClient {
    return this._client as MockClient;
  }

  get lwm2m(): MockServiceCallRunner {
    return this._lwm2m as MockServiceCallRunner;
  }

  constructor(options?: MockTap.InstanceOptions) {
    super(createMockClient(options) as any);
  }

  // public _mockConfig?: TapConfiguratorConfig;

  // constructor() {
  //     super(new MockClient());
  // }

  // get client(): MockClient {
  //     return this._client as MockClient;
  // }

  // // TODO
  // setCallHandler(call: (options: ServiceCallType) => Promise<TapResponse<any>>) {
  //     // for (const service of this.service.list()) {
  //     //     service._call = call;
  //     // }
  //     // this._lwm2m.call = call;
  //     return this;
  // }

  // async mockSetAuthSession(options: {
  //     username: string;
  //     groupId?: number;
  //     sessionKey?: Uint8Array;
  // }) {
  //     if (options.sessionKey) {
  //         this._scramInterceptor.sessionKey = options.sessionKey;
  //         await this._scramInterceptor.encryption(true, false, false);
  //     }

  //     this._sessionState$.next({
  //         groupId: options.groupId || 1,
  //         name: options.username,
  //         lifeTime: 300,
  //         startTime: new Date()
  //     });
  // }

  // static sensorDemo() {
  //     const tap = new MockTap();

  //     tap.mockSetConfig({
  //         meta: {
  //             version: '1.0.0'
  //         },
  //         config: {
  //             version: '1.0.0',
  //             application: {
  //                 name: 'Sensor demo',
  //                 android: {
  //                     aar: 'com.iotize.android.tapmanager'
  //                 },
  //                 universalLink: 'https://iotize.com'
  //             },
  //             data: {
  //                 bundles: [

  //                 ],
  //                 profiles: [
  //                     {
  //                         id: 65535,
  //                         username: 'admin',
  //                         password: 'admin',
  //                         lifeTime: 300
  //                     }
  //                 ]
  //             },
  //             tap: {

  //             },
  //             target: {

  //             }
  //         }
  //     });
  //     return tap;
  // }

  // public mockSetConfig(schema: TapConfiguratorConfig) {
  //     this._mockConfig = schema;
  // }
}
